"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_helmet_1 = require("react-helmet");
const integrator_root_1 = require("../../integrator-root");
const theme_provider_1 = require("../../theme-provider");
const StyledDemoRoot = theme_provider_1.styled.div.withConfig({ displayName: "StyledDemoRoot", componentId: "sc-9e0ymn" }) `
	margin: ${props => (props.showMargin ? '40px 0 20px' : '0')};
	position: relative;

	/*
		The fallback urls that start with a slash instead of a dot are needed to get the fonts
		in the local development environment.
		The '/api/static/' urls are for when the component is used inside patternplate.
	 */
	@font-face {
		font-family: 'vw-head';
		font-weight: 400;
		src: url('/api/static/fonts/vwhead-regular.woff2') format('woff2'),
			url('./public/fonts/vwhead-regular.woff2') format('woff2'),
			url('/public/fonts/vwhead-regular.woff2') format('woff2');
	}
	@font-face {
		font-family: 'vw-head';
		font-weight: 400;
		font-style: italic;
		src: url('/api/static/fonts/vwhead-regularitalic.woff2') format('woff2'),
			url('./public/fonts/vwhead-regularitalic.woff2') format('woff2'),
			url('/public/fonts/vwhead-regularitalic.woff2') format('woff2');
	}
	@font-face {
		font-family: 'vw-head';
		font-weight: 700;
		src: url('/api/static/fonts/vwhead-bold.woff2') format('woff2'),
			url('./public/fonts/vwhead-bold.woff2') format('woff2'),
			url('/public/fonts/vwhead-bold.woff2') format('woff2');
	}
	@font-face {
		font-family: 'vw-head';
		font-weight: 700;
		font-style: italic;
		src: url('/api/static/fonts/vwhead-bolditalic.woff2') format('woff2'),
			url('./public/fonts/vwhead-bolditalic.woff2') format('woff2'),
			url('/public/fonts/vwhead-bolditalic.woff2') format('woff2');
	}
	@font-face {
		font-family: 'vw-head';
		font-weight: 800;
		src: url('/api/static/fonts/vwhead-extrabold.woff2') format('woff2'),
			url('./public/fonts/vwhead-extrabold.woff2') format('woff2'),
			url('/public/fonts/vwhead-extrabold.woff2') format('woff2');
	}
	@font-face {
		font-family: 'vw-head';
		font-weight: 200;
		src: url('/api/static/fonts/vwhead-light.woff2') format('woff2'),
			url('./public/fonts/vwhead-light.woff2') format('woff2'),
			url('/public/fonts/vwhead-light.woff2') format('woff2');
	}

	@font-face {
		font-family: 'vw-text';
		font-weight: 400;
		src: url('/api/static/fonts/vwtext-regular.woff2') format('woff2'),
			url('./public/fonts/vwtext-regular.woff2') format('woff2'),
			url('/public/fonts/vwtext-regular.woff2') format('woff2');
	}
	@font-face {
		font-family: 'vw-text';
		font-weight: 400;
		font-style: italic;
		src: url('/api/static/fonts/vwtext-regularitalic.woff2') format('woff2'),
			url('./public/fonts/vwtext-regularitalic.woff2') format('woff2'),
			url('/public/fonts/vwtext-regularitalic.woff2') format('woff2');
	}
	@font-face {
		font-family: 'vw-text';
		font-weight: 700;
		src: url('/api/static/fonts/vwtext-bold.woff2') format('woff2'),
			url('./public/fonts/vwtext-bold.woff2') format('woff2'),
			url('/public/fonts/vwtext-bold.woff2') format('woff2');
	}
	@font-face {
		font-family: 'vw-text';
		font-weight: 700;
		font-style: italic;
		src: url('/api/static/fonts/vwtext-bolditalic.woff2') format('woff2'),
			url('./public/fonts/vwtext-bolditalic.woff2') format('woff2'),
			url('/public/fonts/vwtext-bolditalic.woff2') format('woff2');
	}
	@font-face {
		font-family: 'vw-text';
		font-weight: 200;
		src: url('/api/static/fonts/vwtext-light.woff2') format('woff2'),
			url('./public/fonts/vwtext-light.woff2') format('woff2'),
			url('/public/fonts/vwtext-light.woff2') format('woff2');
	}

	@font-face {
		font-family: 'vw-head-ar';
		font-weight: 700;
		src: url('/api/static/fonts/HelveticaNeueArabicBD.woff') format('woff'),
			url('./public/fonts/HelveticaNeueArabicBD.woff') format('woff'),
			url('/public/fonts/HelveticaNeueArabicBD.woff') format('woff');
	}
	@font-face {
		font-family: 'vw-text-ar';
		font-weight: 400;
		src: url('/api/static/fonts/HelveticaNeueArabicLT.woff') format('woff'),
			url('./public/fonts/HelveticaNeueArabicLT.woff') format('woff'),
			url('/public/fonts/HelveticaNeueArabicLT.woff') format('woff');
	}
`;
StyledDemoRoot.displayName = 'StyledDemoRoot';
const StyledDemoGrid = theme_provider_1.styled.div.withConfig({ displayName: "StyledDemoGrid", componentId: "sc-1jwvzw2" }) `
	display: ${props => (props.alwaysVisible ? 'block' : 'none')};
	position: absolute;
	top: 0;
	left: 0;
	bottom: 0;
	right: 0;
	pointer-events: none;
	z-index: 100;
	height: 100%;
	background: repeating-linear-gradient(
		to right,
		rgba(255, 194, 244, 0.1) 0%,
		rgba(255, 194, 244, 0.1) ${100 / 24}%,
		rgba(255, 194, 244, 0.3) ${100 / 24}%,
		rgba(255, 191, 244, 0.3) ${(100 / 24) * 2}%,
		rgba(255, 194, 244, 0.1) ${(100 / 24) * 2}%
	);
	max-width: 2560px;
	margin: auto;
`;
const StyledDemoGridLabel = theme_provider_1.styled.label.withConfig({ displayName: "StyledDemoGridLabel", componentId: "sc-1feea1y" }) `
	position: fixed;
	bottom: 8px;
	right: 8px;
	color: black;
	font-size: 16px;
	padding: 0 8px;
	background: white;
	border: 1px solid black;
	opacity: 0.3;
	cursor: pointer;
	font-weight: bold;
	transition: opacity ease-in-out 0.25s;
	border-radius: 12px;

	&:hover {
		opacity: 1;
	}
`;
const StyledDemoGridCheckbox = theme_provider_1.styled.input.withConfig({ displayName: "StyledDemoGridCheckbox", componentId: "sc-1glyxnw" }) `
	position: fixed;
	top: 0;
	left: 0;
	transform: translate(-200%, -200%);
	&:checked {
		~ ${StyledDemoGrid} {
			display: block;
		}
	}
`;
/**
 * DemoRoot component
 *
 * Provides a wrapper element for component demos. This wrapper includes styles as well as global definitions like theme definitions.
 *
 * @param props Component properties
 */
class DemoRoot extends React.Component {
    constructor(props) {
        super(props);
        this.renderMetaInfo = () => (React.createElement("meta", { name: "viewport", content: "width=device-width, initial-scale=1" }));
        this.state = {
            language: undefined
        };
    }
    componentDidMount() {
        // **************
        // WARNING START: this is NOT how this libary should be included! Have a look into the 'Dos and don’ts' in the index.md
        // **************
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (typeof window.lazySizes === 'undefined') {
            // loading the 3rd party lib asynchronous for the demo, in order to prevent server-side-rendering issues and easily avoid them
            const scriptElement = document.createElement('script');
            scriptElement.src =
                'https://afarkas.github.io/lazysizes/lazysizes.min.js';
            scriptElement.type = 'text/javascript';
            document.body.appendChild(scriptElement);
        }
        // ***********
        // WARNING END
        // ***********
    }
    render() {
        const { children, showGrid, showGridOverlayToggle, hideMargin = false } = this.props;
        const { language } = this.state;
        return (React.createElement(integrator_root_1.IntegratorRoot, { language: language },
            React.createElement(react_helmet_1.Helmet, null, this.renderMetaInfo()),
            React.createElement(StyledDemoRoot, { showMargin: !hideMargin },
                showGridOverlayToggle && (React.createElement(React.Fragment, null,
                    React.createElement(StyledDemoGridLabel, { htmlFor: "showGrid" }, "IIIIIIII"),
                    React.createElement(StyledDemoGridCheckbox, { id: "showGrid", type: "checkbox" }),
                    React.createElement(StyledDemoGrid, null))),
                showGrid && React.createElement(StyledDemoGrid, { alwaysVisible: true }),
                children)));
    }
}
exports.DemoRoot = DemoRoot;
